/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { AppointmentDetailComponent } from './appointment-detail/appointment-detail.component';
import { AppointmentListComponent } from './appointment-list/appointment-list.component';

@NgModule({
  declarations: [
    AppointmentListComponent,
    AppointmentDetailComponent
  ],
  imports: [SharedModule],
  exports: [AppointmentListComponent]
})
export class AppointmentsModule { }
